/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class CustomActionWorkflowBlock extends SingleOutputWorkflowBlock {

        private outerRadius: number;
        private innerRadius: number;
        private numberOfPoints: number;
        private xPadding: number;
        private yPadding: number;
        private attributes: any;


        constructor(id: string, label: string) {
            super(id, Wars.Domain.Model.Codes.Enums.BlockType.CustomAction, label);
            this.outerRadius = 85 / 2;
            this.innerRadius = 50 / 2;
            this.numberOfPoints = 5;
            this.xPadding = (this.blockWidth - (this.outerRadius * 2)) / 2;
            this.yPadding = (this.blockHeight - (this.outerRadius * 2)) / 2;

            this.attributes = {
                id: this.id,
                class: "action-workflow-block",
                transform: 'r-18',
                "data-class": "workflowBlock",
                "data-id": "customAction"
            };
        }
    }
}